<div class="header">
  {{ title }}
  <app-pencil-button
    *ngIf="hasCloseButton"
    class="modal-close-button"
    (clickEvent)="handleClose($event)"
    icon="close"
    [iconConfig]="{
      type: 'material-icon'
    }"
  ></app-pencil-button>
</div>
<div class="content">
  <div class="content-img">
    <ng-content select="[content-img]"></ng-content>
  </div>
  <div class="description">
    <ng-content select="[content-description]"></ng-content>
  </div>
  <div class="actions" *ngIf="hasActions" [class.actions-divider]="showActionsDivider">
    <ng-content select="[content-actions]"></ng-content>
  </div>
</div>
